import SnackbarWrapper from './SnackbarWrapper';

export default SnackbarWrapper;
